enum Dimen {
  FontSizeDefault = "20px",
  FontSizeHeading = "40px",
  FontSizeSubHeading = "30px",
  FontSizeSubHeading2 = "25px",
  MarginDefault = "16px",
  PaddingDefault = "16px",
  MarginDefault2x = "32px",
}

export default Dimen;
